module.exports = {
          srcSet: __webpack_public_path__ + "bbc53ec8656c2f2e22dd49d778597d6a-674.png"+" 674w",
          images:[ {path: __webpack_public_path__ + "bbc53ec8656c2f2e22dd49d778597d6a-674.png",width: 674,height: 141}],
          src: __webpack_public_path__ + "bbc53ec8656c2f2e22dd49d778597d6a-674.png",
          toString:function(){return __webpack_public_path__ + "bbc53ec8656c2f2e22dd49d778597d6a-674.png"},
          
          width: 674,
          height: 141
        }